import { render } from "./Help-center-hint.vue?vue&type=template&id=2da059af&scoped=true"
import script from "./Help-center-hint.vue?vue&type=script&lang=js"
export * from "./Help-center-hint.vue?vue&type=script&lang=js"

import "./Help-center-hint.vue?vue&type=style&index=0&id=2da059af&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da059af"]])

export default __exports__